/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ICompanyQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ICompanyQuery = {
  __typename?: 'Query';
  company: {
    __typename?: 'Company';
    city?: string | null;
    invitationStatus: Types.CompanyInvitationStatusEnum;
    companyName?: string | null;
    companyRegistration?: string | null;
    companyWebsite?: string | null;
    country?: string | null;
    id: string;
    postalCode?: string | null;
    region?: string | null;
    street?: string | null;
    streetNumber?: string | null;
    subscriptionCancellationRequestedAt?: any | null;
    subscriptionExclusiveCouponAppliedAt?: any | null;
    ssoEnabled: boolean;
    policy: {
      __typename?: 'CompanyPolicy';
      createUser: boolean;
      update: boolean;
      readBilling: boolean;
      createIntegration: boolean;
      readIntegrations: boolean;
      readAuditLog: boolean;
      createBackup: boolean;
      createCustodianProfile: boolean;
      createEscrow: boolean;
    };
  };
};

export const CompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'company' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invitationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionCancellationRequestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionExclusiveCouponAppliedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssoEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createUser' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readBilling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createIntegration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readIntegrations' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readAuditLog' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createBackup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createCustodianProfile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createEscrow' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ICompanyQuery, ICompanyQueryVariables>;
